
import {defineComponent} from "vue";
import {stringHasContent} from "@/helpers/functions/string";
import {ContentPageRestService} from "@/services/rest/cms-content-page/ContentPageRestService";

export default defineComponent({
  name: "ButtonContentPageSaveAbstract",
  emits: ["exceptions"],
  props: {
    /**
     * The page whose overview content block is written. Handed down by the screen that owns the page
     * instead of read from a store, so this button always writes the page it is rendered for.
     */
    pageId: {
      type: String,
      required: true,
    },
    content: {
      type: String,
      required: false,
    },
    image: {
      type: String,
      required: false,
    },
    title: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
      isSubmitting: false as boolean,
      savedSuccessfully: false as boolean,
    }
  },
  computed: {
    hasContentToUse(): boolean {
      return stringHasContent(this.content) || stringHasContent(this.image) || stringHasContent(this.title);
    },
  },
  methods: {
    async saveContentPageOverviewCb() {
      this.isSubmitting = true;
      this.savedSuccessfully = false;

      try {
        if (stringHasContent(this.content)) {
          await ContentPageRestService.getInstance()
            .updateContentPageOverviewCbContent(this.content as string, this.pageId);
        }
        if (stringHasContent(this.image)) {
          await ContentPageRestService.getInstance()
            .updateContentPageOverviewCbImage(this.image as string, this.pageId);
        }
        if (stringHasContent(this.title)) {
          await ContentPageRestService.getInstance()
            .updateContentPageOverviewCbTitle(this.title as string, this.pageId);
        }

        this.savedSuccessfully = true;
        setTimeout(() => this.savedSuccessfully = false, 2000);
      } catch (exceptions: any) {
        this.$emit('exceptions', exceptions);
      } finally {
        this.isSubmitting = false;
      }
    }
  }
});
